import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import 'jspdf-autotable';
import Icon3 from '../../assest/images//Icon3.png';
import { UserContext } from '../common/UserContext';
import config from '../../envconfig';
import Icon7 from '../../assest/images/Icon7.png'
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import { IoCaretUpOutline, IoCaretDownOutline, IoCalendarOutline } from 'react-icons/io5';
import Select from 'react-select';
import CustomDatepicker from "../common/CustomDatePicker";
import CustomDropdown from '../common/CustomDropdown';

const OrderVerification = () => {
  const [orderData1, setOrderData1] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10); // Changed to show 10 records per page
  const [filterOptions,] = useState(['Order Number', 'Order Date']);
  const [selectedFilter1, setSelectedFilter1] = useState('Order Number');
  const [selectedOrderStatus, setSelectedOrderStatus] = useState('');
  const [searchText1, setSearchText1] = useState('');
  const [reload, setReload] = useState(false);
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);



  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isToOpen, setIsToOpen] = useState(false);

  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [searchOpt1, setSearchOpt1] = useState('');
  const [searchOpt2, setSearchOpt2] = useState('');
  const [searchTxt1, setSearchTxt1] = useState('');

  const [searchTxt2, setSearchTxt2] = useState('');

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');


  const logAction = async (action, isError = false) => {
    console.log(`${isError ? '[ERROR] ' : ''}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Order Approval", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };


  useEffect(() => {
    fetchOrderData();
  }, []);


  useEffect(() => {
    if (selectedFilter1) {
    }
  }, [selectedFilter1, filterOptions]);
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };
  const fetchOrderData = async () => {
    try {
      const response = await fetch(`${config.API_URL}/OA/ProductViewOV/${selectedScpId}`);
      if (response.ok) {
        const data = await response.json();
        console.log("data", data)
        const orderMap = new Map();
        data.forEach(order => {
          const orderNumber = order.ORDM_OrderNumber;
          const createdTimestamp = new Date(order.ORDIT_CreatedTimestamp);
          if (orderMap.has(orderNumber)) {
            const existingCreatedTimestamp = new Date(orderMap.get(orderNumber).ORDIT_CreatedTimestamp);
            if (createdTimestamp > existingCreatedTimestamp) {
              orderMap.set(orderNumber, order);
            }
          } else {
            orderMap.set(orderNumber, order);
          }
        });
        const uniqueOrders = Array.from(orderMap.values());
        uniqueOrders.sort((a, b) => new Date(b.ORDIT_CreatedTimestamp) - new Date(a.ORDIT_CreatedTimestamp));
        setOrderData(uniqueOrders);
      } else {
        console.error('Failed to fetch order data');
      }
    } catch (error) {
      console.error('Error fetching order data:', error);
    }
  };
  const filterOrderData = () => {
    let filteredData = orderData;



    let dateMatch = true;

    if (startDate && endDate) {
      const itemDate = new Date(filteredData.ORDM_OrderDate);
      const start = new Date(startDate);
      const end = new Date(endDate);
      itemDate.setHours(0, 0, 0, 0);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      dateMatch = itemDate >= start && itemDate <= end;
    }

    filteredData = filteredData.filter(item => {
      const fieldMatch1 = !searchTxt1 || !searchOpt1 || String(item[searchOpt1]).toLowerCase().includes(searchTxt1.toLowerCase());
      const fieldMatch2 = !searchTxt2 || !searchOpt2 || String(item[searchOpt2]).toLowerCase().includes(searchTxt2.toLowerCase());

      let dateMatch = true;
      if (startDate && endDate) {
        const itemDate = new Date(item.ORDM_OrderDate);
        const start = new Date(startDate);
        const end = new Date(endDate);
        itemDate.setHours(0, 0, 0, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        dateMatch = itemDate >= start && itemDate <= end;
      }
      return fieldMatch1 && fieldMatch2 && dateMatch;
    });

    return filteredData;
  };

  const totalPages = Math.ceil(filterOrderData().length / ordersPerPage);
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filterOrderData().slice(indexOfFirstOrder, indexOfLastOrder);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pagesArray = Array.from({ length: totalPages }, (_, index) => index + 1);

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

const options = [
  { 
    value: 'ToSCP_Name', 
    label: 'To', 
    disabled: searchOpt1 === 'ToSCP_Name' || searchOpt2 === 'ToSCP_Name'
  },
  { 
    value: 'ORDM_OrderNumber', 
    label: 'Order Number', 
    disabled: searchOpt1 === 'ORDM_OrderNumber' || searchOpt2 === 'ORDM_OrderNumber'
  },
  { 
    value: 'Description', 
    label: 'Order Type', 
    disabled: searchOpt1 === 'Description' || searchOpt2 === 'Description'
  },
  { 
    value: 'ORDM_OrderDate', 
    label: 'Order Date', 
    disabled: searchOpt1 === 'ORDM_OrderDate' || searchOpt2 === 'ORDM_OrderDate'
  },
];

const options2 = [
  { 
    value: 'ToSCP_Name', 
    label: 'To', 
    disabled: searchOpt2 === 'ToSCP_Name' || searchOpt1 === 'ToSCP_Name'
  },
  { 
    value: 'ORDM_OrderNumber', 
    label: 'Order Number', 
    disabled: searchOpt2 === 'ORDM_OrderNumber' || searchOpt1 === 'ORDM_OrderNumber'
  },
  { 
    value: 'Description', 
    label: 'Order Type', 
    disabled: searchOpt2 === 'Description' || searchOpt1 === 'Description'
  },
  { 
    value: 'ORDM_OrderDate', 
    label: 'Order Date', 
    disabled: searchOpt2 === 'ORDM_OrderDate' || searchOpt1 === 'ORDM_OrderDate'
  },
];

  const handleOpt1 = (selectedOption) => {
  const newValue = selectedOption?.target?.value || '';

  if (newValue !== searchOpt1) {
    setSearchOpt1(newValue);
    setSearchTxt1('');
  }

  if (newValue !== 'ORDM_OrderDate' && searchOpt2 !== 'ORDM_OrderDate') {
    setStartDate('');
    setEndDate('');
  }
};


const handleOpt2 = (selectedOption) => {
  const newValue = selectedOption?.target?.value || '';

  if (newValue !== searchOpt2) {
    setSearchOpt2(newValue);
    setSearchTxt2('');
  }

  if (newValue !== 'ORDM_OrderDate' && searchOpt1 !== 'ORDM_OrderDate') {
    setStartDate('');
    setEndDate('');
  }
};


  const handleTxt1 = (e) => {
    setSearchTxt1(e.target.value);
  };



  const handleTxt2 = (e) => {
    setSearchTxt2(e.target.value);
  };


  return (
    <React.Fragment>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      <div className='main_container'>
        <div className='row'>
          <div className='col-md-12'>
            <div>
              <h4 className="formHeading">Order Approval</h4>
            </div>

            <div className="filter-container">
              <div className='select-container_list'>
              <CustomDropdown
  name="searchOpt1"
  options={options2}
  value={searchOpt1}                          // store only value
  onChange={(option) => handleOpt1(option)}   // receives full object
  placeholder="--Select--"
  idKey="value"                               // key used in options
  displayKey="label"                          // key used to show text
  disabled={false}
  onMenuOpen={() => handleSelectOpen("searchOpt1")}
  onMenuClose={handleSelectClose}
/>



             


              </div>
              <input type='text' value={searchTxt1} onChange={handleTxt1} className='search-input searchbar' placeholder="Search"></input>

              <div className='select-container_list'>
              <CustomDropdown
  name="searchOpt2"
  options={options}
  value={searchOpt2}                           // only selected value
  onChange={(option) => handleOpt2(option)}    // full object passed
  placeholder="--Select--"
  idKey="value"                                // must match your option keys
  displayKey="label"                           // must match your option keys
  disabled={false}
  onMenuOpen={() => handleSelectOpen("searchOpt2")}
  onMenuClose={handleSelectClose}
/>

               

              </div>
              <input type='text' value={searchTxt2} onChange={handleTxt2} className='search-input searchbar' placeholder="Search"></input>

            </div>



            {(searchOpt1 === 'ORDM_OrderDate' || searchOpt2 === 'ORDM_OrderDate') && (
              <div className="filter-container">
                {/* From Date Picker */}
                <div className="from-container" style={{ flex: 1 }}>
                  <label>From</label>
                  <div className="select-container_list">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);

                        // If the "From" date is cleared, clear the "To" date as well
                        if (!date) {
                          setEndDate(null);
                        }

                        // If the "To" date picker is empty, set it to the same value as the "From" date
                        if (!endDate && date) {
                          setEndDate(date);
                        }
                      }}
                      dateFormat="dd/MM/yyyy"
                      showPopperArrow={false}
                      popperPlacement="bottom"
                      className="routing_select-box" // Optional: your custom class
                      placeholderText="--Select--"
                      maxDate={new Date()}  // Set max date to today
                      onKeyDown={(e) => e.preventDefault()}
                      customInput={<CustomDatepicker />}
                    />

                    {/* Calendar Icon */}
                    <div className='icon-container_list myList'>
                      <i><IoCalendarOutline /></i>
                    </div>
                  </div>
                </div>

                {/* To Date Picker */}
                <div className="to-container" style={{ flex: 1 }}>
                  <label>To</label>
                  <div className="select-container_list">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="dd/MM/yyyy"
                      showPopperArrow={false}
                      popperPlacement="bottom"
                      onKeyDown={(e) => e.preventDefault()}
                      className="routing_select-box" // Optional: your custom class
                      placeholderText="--Select--"
                      minDate={startDate} // Disable same day as 'From' date
                      disabled={!startDate} // Disable 'To' date picker if 'From' date is not selected
                      maxDate={new Date()}  // Set max date to today
                      customInput={<CustomDatepicker />}
                    />
                    {/* Calendar Icon */}
                    <div className='icon-container_list myList'>
                      <i><IoCalendarOutline /></i>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="ptable-wrapper">
          <table className="ptableClass" key={reload ? 'reload-1' : 'reload-2'}>
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>To</th>
                <th>Order Number</th>
                <th>Order Type</th>
                <th>Order Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length === 0 ? (
                <tr>
                  <td colSpan="6">No Records Found</td>
                </tr>
              ) : (
                currentOrders.map((item, index) => (
                  <tr key={index} style={{ height: "30px" }}>
                    <td>{indexOfFirstOrder + index + 1}</td>
                    <td>{item.ToSCP_Name}</td>
                    <td>{item.ORDM_OrderNumber}</td>
                    <td>{item.Description}</td>
                    <td>{formatDate(item.ORDM_OrderDate)}</td>
                    <td>
                      {item.ORDM_OrderStatus === 1 && <></>}
                      <Link
                        to={`/dashboard/EditOrderStatus/${item.ORDM_OrderNumber}`}
                        onClick={() => logAction(`Redirecting to Edit - ${item.ORDM_OrderNumber}`)}
                      >
                        <img title="Edit" src={Icon3} alt="View" />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>

          </table>
        </div>

        <ul className="pagination">
          {/* First Page Button */}
          <li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(1)}>First</button>
          </li>

          {/* Previous Page Button */}
          <li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
          </li>

          {/* Page Numbers */}
          {pagesArray.map((number) => (
            <li key={number} className={currentPage === number ? "page-item active" : "page-item"}>
              <button className="page-linkd" onClick={() => paginate(number)}>{number}</button>
            </li>
          ))}

          {/* Next Page Button */}
          <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
          </li>

          {/* Last Page Button */}
          <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
            <button className="page-linkd" onClick={() => paginate(totalPages)}>Last</button>
          </li>
        </ul>

      </div>
    </React.Fragment >
  );
};
export default OrderVerification;